<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="cubes"/>
          {{$t("autoCallGateway")}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('name') }}</div>
            <div class="col-lg-3">{{ $t('fee') }}</div>
            <div class="col-lg-3">{{ $t('time') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <div><b>{{ $t('gatewayCode') }}: </b><span>{{ item.code }}</span></div>
              <div><b>{{ $t('gatewayName') }}: </b><span>{{ item.name }}</span></div>
              <div v-if="item.desc"><b>{{ $t('desc') }}: </b><span>{{ item.desc }}</span></div>
              <div v-if="item.username"><b>{{ $t('username') }}: </b><span>{{ item.username ? item.username : '--' }}</span></div>
            </div>
            <div class="col-lg-3">
              <p><b>{{ $t('fee') }}: </b><span>{{ item.fee | numFormat }}</span></p>
            </div>
            <div class="col-lg-3">
              <p><b>{{ $t('createTime') }}: </b><span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span></p>
              <p v-if="item.updateTime"><b>{{
                  $t('updateTime')
                }}: </b><span>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span></p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" v-if="['owner', 'admin'].includes($store.state.user.role)"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
        <form-input :label="$t('gatewayCode')" :model="formModel" attribute="code" :errors="formErrors"></form-input>
        <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"></form-input>
        <form-input :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"></form-input>
        <form-input :label="$t('fee')" :model="formModel" attribute="fee" :errors="formErrors"></form-input>
        <form-input :label="$t('username')" :model="formModel" attribute="username" :errors="formErrors"></form-input>
        <form-input :label="$t('pwd')" :model="formModel" attribute="pwd" :errors="formErrors"></form-input>

      <form-input :label="$t('callFee')" :model="formModel" attribute="callFee" :errors="formErrors">
      </form-input>
      <form-input :label="$t('minBillSecs')" :model="formModel" attribute="minBillSecs" :errors="formErrors">
      </form-input>
      <form-input :label="$t('blockBillSecs')" :model="formModel" attribute="blockBillSecs" :errors="formErrors">
      </form-input>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/ai-gateway',
      autoLoad: true,
      defaultFormModel: {
        code: null,
        name: null,
        desc: null,
        fee: null,
        username: null,
        pwd: null,
      }
    }
  },
  i18n: {
    messages: {
      en: {
        autoCallGateway: "Auto call: Gateway",
        gatewayName: 'Gateway name',
        fee: 'Fee/Call',
        monthlyFee: 'Monthly advance fee',
        numberOfSms: "Number of messages/advance fee",
        createTime: 'Create time',
        updateTime: 'Update time',
        username: "Username",
        pwd: "Password",
        manual: "Allow brandName to enter user / pass information",
        minAdsMsg: "Minimum advertisement message",
        autoAdsStatus: "Update Ads campaign status automatically",
        gatewayCode: "Code",
        minBillSecs: 'Số giây tính cước tối thiểu',
        blockBillSecs: 'Số giây / block tính cước',
        callFee: "Giá cước / block"
      },
      vi: {
        gatewayCode: "Mã gateway",
        autoCallGateway: "Gọi tự động: Gateway",
        gatewayName: 'Tên gateway',
        fee: 'Phí/Cuộc gọi',
        monthlyFee: 'Phí ứng trước hàng tháng',
        numberOfSms: "Số tin nhắn/phí ứng trước",
        createTime: 'Tạo lúc',
        updateTime: 'Cập nhật lúc',
        username: "Tên đăng nhập",
        pwd: "Mật khẩu",
        manual: "BrandName nhập User/Password",
        minAdsMsg: "Số tin nhắn quảng cáo tối thiểu",
        autoAdsStatus: "Tự động cập nhật trạng thái chiến dịch quảng cáo",
        minBillSecs: 'Số giây tính cước tối thiểu',
        blockBillSecs: 'Số giây / block tính cước',
        callFee: "Giá cước / block"
      }
    }
  },
  methods: {}
};
</script>